<style type="text/css" media="screen" scoped>
.shipment-stats-card{
	background: #FFFFFF;
	box-shadow: 0px 5px 10px rgba(157, 149, 149, 0.25);
	border-radius: 25px;
}
.status_text{
	font-style: normal;
	font-weight: bold;
	font-size: 14px;
	line-height: 19px;
	display: flex;
	letter-spacing: 0.015em;
	color: #9C9C9C;
}
.shipment_counts{
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 22px;
	display: flex;
	align-items: center;
	letter-spacing: 0.015em;
	color: #333232;
}
.stats-list-item{
	min-height: unset !important;
	padding: 5px 0px !important;
}
/*wallet card*/
.wallet-stats-card{
	border: 2px solid #1DC895;
	background: #FFFFFF;
	box-sizing: border-box;
	border-radius: 25px;
	padding: 5px 10px;
	margin-top: 15px;
}
.wallet-stats-card span{
	font-weight: bold;
	font-size: 14px;
	line-height: 19px;
	letter-spacing: 0.015em;
	color: #4F4D4D;
}
.wallet-stats-card .wallet-amont{
	font-style: normal;
	font-weight: 800;
	font-size: 36px;
	line-height: 49px;
	letter-spacing: 0.015em;
	color: #4F4D4D;
}


</style>

<template>
	<div>
		<!-- shipment over view -->
		<div class="shipment-stats-card px-5 pb-5">
			<v-list disabled>
				<v-subheader class="px-0"><span class="sub-title-text">{{$lang.SHIPMENTS}}</span></v-subheader>
				<v-list-item-group>
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.out_for_delivery_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.OUT_FOR_DELIVERY}}
						</v-list-item-content>
					</v-list-item>
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.delivered_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.DELIVERED}}
						</v-list-item-content>
					</v-list-item>


					<v-divider></v-divider>
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.new_order_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.NEW_ORDERS}}
						</v-list-item-content>
					</v-list-item>
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.picked_up_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.PICKED_UP_TODAY}}
						</v-list-item-content>
					</v-list-item>
					<v-divider></v-divider>

<!-- 
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.to_be_returned_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.TO_BE_RETURNED}}
						</v-list-item-content>
					</v-list-item> -->
					<v-list-item class="stats-list-item">
						<v-list-item-icon class="shipment_counts mr-3 my-0">
							{{over_view_data.returned_count}}
						</v-list-item-icon>
						<v-list-item-content class="status_text py-0">
							{{$lang.RETURNED}}
						</v-list-item-content>
					</v-list-item>



				</v-list-item-group>
			</v-list>
		</div>

		<!-- wallet over view-->
		<div class="wallet-stats-card px-3 "> 
			<span class="px-2">{{$lang.IN_WALLET}}</span>
			<div class="wallet-amont">
				<v-icon color="#4F4D4D" size="36px"
				style="margin-top:-4px; margin-right:-12px"
				>mdi-currency-inr</v-icon>
				{{over_view_data.wallet_amount}}
			</div>


		</div>

	</div>
</template>

<script type="text/javascript">
export default {
	props:['over_view_data']
}


</script>